import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './rush.css';
import './integrations.css';
import { RushNav, RushFooter, useRushReveal } from './RushChrome';
import { INTEGRATIONS, CATEGORIES } from './integrationsData';

const CUSTOM_LOGOS = {
  slack: (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313z" fill="#E01E5A" />
      <path d="M8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312z" fill="#36C5F0" />
      <path d="M18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312z" fill="#2EB67D" />
      <path d="M15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" fill="#ECB22E" />
    </svg>
  ),
  microsoftteams: (
    <svg viewBox="0 0 24 24"><path d="M20.625 8.127h-8.25c-.622 0-1.125.504-1.125 1.126v8.247c0 .621.503 1.126 1.125 1.126h8.25c.622 0 1.125-.505 1.125-1.126V9.253c0-.622-.503-1.126-1.125-1.126zm-1.5 3.001H17.25v6.498h-1.5v-6.498H13.875v-1.5h5.25v1.5z" fill="#7B83EB" /><circle cx="17.625" cy="5.252" r="2.502" fill="#7B83EB" /><path d="M11.25 7.502c0-2.071-1.679-3.75-3.75-3.75s-3.75 1.679-3.75 3.75 1.679 3.75 3.75 3.75 3.75-1.679 3.75-3.75z" fill="#5059C9" /><path d="M2.25 13.502h10.5v8.25c0 .621-.504 1.125-1.125 1.125H3.375a1.125 1.125 0 0 1-1.125-1.125v-8.25z" fill="#4B53BC" /><path d="M8.625 15.002H6.75v6h-1.5v-6H3.375v-1.5h5.25v1.5z" fill="#fff" /></svg>
  ),
  microsoftonedrive: (
    <svg viewBox="0 0 24 24"><path d="M10.5 4.5a6 6 0 0 0-5.872 4.78 4.5 4.5 0 0 0-.49 8.69 4.5 4.5 0 0 1 .118-.07h14.122a3.75 3.75 0 0 0 .53-7.47 5.25 5.25 0 0 0-8.408-5.93z" fill="currentColor" /></svg>
  ),
  amazons3: (
    <svg viewBox="0 0 24 24"><path d="M3.75 5.5l8.25-2.25 8.25 2.25v3l-8.25 2.25-8.25-2.25v-3z" fill="#E25444" /><path d="M3.75 8.5v6.5c0 2.485 3.694 4.5 8.25 4.5s8.25-2.015 8.25-4.5V8.5l-8.25 2.25L3.75 8.5z" fill="#7B1D13" /><ellipse cx="12" cy="15" rx="6" ry="1.5" fill="#fff" opacity="0.2" /><text x="12" y="17" textAnchor="middle" fill="#fff" fontSize="5" fontWeight="700" fontFamily="Inter, sans-serif">S3</text></svg>
  ),
  adobexd: (
    <svg viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="4" fill="#470137" /><path d="M9 8L7 12l2 4M15 8l2 4-2 4" stroke="#FF61F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" /></svg>
  ),
  klaviyo: (
    <svg viewBox="0 0 24 24"><path d="M12 2L2 9l4 2.5c1.5-2 3.5-3 6-3s4.5 1 6 3L22 9 12 2zm0 8a4 4 0 0 0-3.6 2.3L12 14l3.6-1.7A4 4 0 0 0 12 10zm-6 4l-2 3.5L12 22l8-4.5L18 14a8 8 0 0 1-12 0z" fill="currentColor" /></svg>
  ),
  customerio: (
    <svg viewBox="0 0 24 24"><path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.3l7.5 3.7L12 11.7 4.5 8 12 4.3zm-8 5.4l7 3.5v7.4L4 17.2V9.7zm16 0v7.5l-7 3.4v-7.4l7-3.5z" fill="currentColor" /></svg>
  ),
  mondaydotcom: (
    <svg viewBox="0 0 24 24"><ellipse cx="5" cy="12" rx="2.4" ry="9" fill="#FF3D57" /><ellipse cx="12" cy="12" rx="2.4" ry="9" fill="#FFCB00" /><ellipse cx="19" cy="12" rx="2.4" ry="9" fill="#00CA72" /></svg>
  ),
  segment: (
    <svg viewBox="0 0 24 24"><path d="M3 8.5h12a1.5 1.5 0 0 1 0 3H3a1.5 1.5 0 0 1 0-3z" fill="currentColor" /><path d="M9 13h12a1.5 1.5 0 0 1 0 3H9a1.5 1.5 0 0 1 0-3z" fill="currentColor" /><circle cx="18" cy="6.5" r="2" fill="currentColor" /><circle cx="6" cy="17.5" r="2" fill="currentColor" /></svg>
  ),
};

const BrandLogo = ({ name, icon, fg, bg, letter, size }) => {
  const [failed, setFailed] = useState(false);
  const color = (fg || '#000').replace('#', '');
  const custom = icon && CUSTOM_LOGOS[icon];
  const showCdn = icon && !custom && !failed;
  return (
    <div className={`brand-logo${size === 'lg' ? ' brand-logo-lg' : ''}`} style={{ background: bg, color: fg, borderColor: bg === '#fff' ? 'var(--line)' : 'transparent' }} aria-hidden="true">
      {custom ? (
        <span className="brand-svg">{custom}</span>
      ) : showCdn ? (
        <img src={`https://cdn.simpleicons.org/${icon}/${color}`} alt={`${name} logo`} onError={() => setFailed(true)} loading="lazy" />
      ) : (
        <span className="brand-letter">{letter}</span>
      )}
    </div>
  );
};

const Hero = () => (
  <section className="int-hero">
    <div className="hero-mesh"></div>
    <div className="rs-container hero-anim" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <span className="hero-eyebrow"><span className="dot"></span>{INTEGRATIONS.length} integrations · more shipping monthly</span>
      <h1 className="int-h1">Plugs into whatever you already use.</h1>
      <p className="int-lead">Storage, design, CMS, project management, dev tools. Pull source files in. Push translations back. No copy-paste, no "where's the latest version" — just sync.</p>
    </div>
  </section>
);

const FEATURED_DETAIL = [
  { name: 'Google Drive', icon: 'googledrive', headline: 'Drive folders, in your dashboard.', desc: 'Connect a folder, and every file in it (and any subfolder) becomes translatable. Translated outputs land back beside the source — same folder, formatting intact.', bg: '#fff', fg: '#1a73e8', letter: 'G', bullets: ['Two-way sync', 'Watch any folder', 'DOCX, slides, sheets'] },
  { name: 'Figma', icon: 'figma', headline: 'Stop emailing PNGs.', desc: "Pull text from your Figma frames, translate, and push edits back into the same layers. Auto-rerun on file changes — designers don't have to think about it.", bg: '#1a1a1a', fg: '#F24E1E', letter: 'F', bullets: ['Text layers in-place', 'Auto-resync on changes', 'Variants supported'] },
  { name: 'GitHub', icon: 'github', headline: 'Localization on every PR.', desc: "When a PR touches i18n files, Rush Studio translates the diff in the languages you've set. The translations open as a follow-up PR your engineers review like any other.", bg: '#1a1a1a', fg: '#fff', letter: 'G', bullets: ['PR-triggered diffs', 'Translation PRs', 'All i18n formats'] },
];

const Spotlights = () => (
  <section className="section-tight" style={{ paddingTop: 24 }}>
    <div className="rs-container">
      <div className="spotlight-grid reveal stagger">
        {FEATURED_DETAIL.map((s) => (
          <article className="spotlight-card" key={s.name}>
            <div className="spotlight-top">
              <BrandLogo name={s.name} icon={s.icon} fg={s.fg} bg={s.bg} letter={s.letter} size="lg" />
              <div className="spotlight-name">{s.name}</div>
            </div>
            <h3 className="spotlight-headline">{s.headline}</h3>
            <p className="spotlight-desc">{s.desc}</p>
            <ul className="spotlight-bullets">
              {s.bullets.map((b) => (
                <li key={b}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  {b}
                </li>
              ))}
            </ul>
            <a className="spotlight-link" href="#">How it works
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10m0 0L8 3m4 4l-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);

function labelFor(catId) {
  const c = CATEGORIES.find((c) => c.id === catId);
  return c ? c.label : catId;
}

const IntegrationCard = ({ i }) => (
  <article className={`int-card int-card-${i.status}`}>
    <BrandLogo name={i.name} icon={i.icon} fg={i.fg} bg={i.bg} letter={i.letter} />
    <div className="int-card-body">
      <div className="int-card-head">
        <span className="int-card-name">{i.name}</span>
        {i.status === 'beta' && <span className="int-status int-status-beta">Beta</span>}
      </div>
      <p className="int-card-desc">{i.desc}</p>
    </div>
    <div className="int-card-foot">
      <span className="int-cat-tag">{labelFor(i.cat)}</span>
      <span className="int-connect">{i.status === 'live' ? 'Learn more →' : 'Notify me'}</span>
    </div>
  </article>
);

const Browser = () => {
  const [cat, setCat] = useState('all');
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return INTEGRATIONS.filter((i) => {
      if (cat !== 'all' && i.cat !== cat) return false;
      if (!q) return true;
      return i.name.toLowerCase().includes(q) || i.desc.toLowerCase().includes(q);
    });
  }, [cat, query]);

  return (
    <section className="section" id="browse">
      <div className="rs-container">
        <div className="section-head reveal">
          <div className="eyebrow">Browse all</div>
          <h2>Pick a category. Pick an integration.</h2>
          <p className="section-lead">Live integrations work today. Beta integrations are in production at a handful of customers — we'll let you in if you ask.</p>
        </div>

        <div className="int-controls reveal">
          <div className="int-search">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <circle cx="8" cy="8" r="5" stroke="currentColor" strokeWidth="1.8" />
              <path d="M12 12l3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            <input type="search" className="input int-search-input" placeholder="Search Figma, Notion, GitHub…" value={query} onChange={(e) => setQuery(e.target.value)} autoComplete="off" />
            {query && (
              <button className="int-search-clear" onClick={() => setQuery('')} aria-label="Clear search">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
              </button>
            )}
          </div>

          <div className="int-cat-chips">
            {CATEGORIES.map((c) => (
              <button key={c.id} className={`filter-chip ${cat === c.id ? 'active' : ''}`} onClick={() => setCat(c.id)}>
                {c.label}
                <span className="int-cat-count">{c.count}</span>
              </button>
            ))}
          </div>

          <div className="int-result-count">
            <span><b>{filtered.length}</b> {filtered.length === 1 ? 'integration' : 'integrations'}</span>
            {(query || cat !== 'all') && <button className="link-btn" onClick={() => { setQuery(''); setCat('all'); }}>Clear filters</button>}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="int-empty reveal">
            <div className="int-empty-icon">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M14 4v6m0 4v10M4 14h6m4 0h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
            </div>
            <h4>Don't see what you need?</h4>
            <p>If you have a tool we don't list, <Link to="/contact">tell us</Link> — or use the API to roll your own in an afternoon.</p>
          </div>
        ) : (
          <div className="int-grid reveal">
            {filtered.map((i) => <IntegrationCard key={i.name} i={i} />)}
          </div>
        )}
      </div>
    </section>
  );
};

const ApiComingSoon = () => (
  <section className="section" style={{ background: 'var(--bg-soft)', borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)' }}>
    <div className="rs-container">
      <div className="api-grid">
        <div className="api-copy reveal">
          <span className="coming-soon-pill"><span className="coming-soon-dot"></span>Coming soon</span>
          <h2 className="api-h">A public API is in the works.</h2>
          <p className="section-lead">Translate any string from anywhere — your CMS, your CRM, your weird internal Rails app. We're hardening it with design partners now and opening it up later this year.</p>
          <div className="api-bullets">
            <div className="api-bullet">
              <span className="api-bullet-icon">↺</span>
              <div><b>REST + webhooks</b><span>Trigger on project create, segment update, file export, deadline alert.</span></div>
            </div>
            <div className="api-bullet">
              <span className="api-bullet-icon">⚡</span>
              <div><b>Idempotent + async</b><span>Long-running translation jobs return a job ID; poll or webhook for the result.</span></div>
            </div>
            <div className="api-bullet">
              <span className="api-bullet-icon">{'{}'}</span>
              <div><b>OpenAPI 3.1 spec</b><span>Official SDKs in TypeScript, Python, Go, and Ruby — generated from the same spec.</span></div>
            </div>
          </div>
          <form className="api-notify" onSubmit={(e) => e.preventDefault()}>
            <input className="input input-lg" placeholder="work@yourcompany.com" type="email" required />
            <button className="btn btn-accent" type="submit">Notify me when it ships →</button>
          </form>
          <div className="api-notify-meta">Design partner spots open · <Link to="/contact">talk to us</Link> if you want early access.</div>
        </div>

        <div className="api-code reveal reveal-scale api-code-soon">
          <div className="api-code-chrome">
            <span className="dots"><span /><span /><span /></span>
            <span className="api-code-lang">curl · translate one string</span>
          </div>
          <pre className="api-code-pre">
            <span className="cm">{'# Translate a single string into German\n'}</span>
            <span className="kw">curl</span> https://api.rush.studio/v1/translate{'\n'}
            {'  -H '}<span className="str">"Authorization: Bearer $RS_TOKEN"</span>{'\n'}
            {'  -H '}<span className="str">"Content-Type: application/json"</span>{'\n'}
            {'  -d '}<span className="str">{`'{ "text": "Welcome to your workspace.", "source": "en", "target": "de" }'`}</span>
          </pre>
          <div className="api-code-overlay">
            <div className="api-code-overlay-card">
              <div className="api-code-overlay-icon">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <rect x="4" y="9" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8" />
                  <path d="M7 9V6a4 4 0 018 0v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  <circle cx="11" cy="14" r="1.4" fill="currentColor" />
                </svg>
              </div>
              <div className="api-code-overlay-title">Preview · Coming soon</div>
              <div className="api-code-overlay-desc">A peek at the planned API. Endpoints, payload shapes, and error semantics are still settling.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const RequestCTA = () => (
  <section className="section">
    <div className="rs-container">
      <div className="final-cta reveal reveal-scale">
        <h2>Missing a tool you depend on?</h2>
        <p>Tell us. We ship 2-3 new integrations a month, prioritized by what customers actually use.</p>
        <form onSubmit={(e) => e.preventDefault()} style={{ display: 'inline-flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          <input className="input input-lg" placeholder="Which tool? (e.g. Confluence)" style={{ width: 300 }} />
          <button className="btn btn-accent btn-lg" type="submit">Request it →</button>
        </form>
      </div>
    </div>
  </section>
);

const RushIntegrationsPage = () => {
  useRushReveal();
  return (
    <div className="rs">
      <RushNav active="integrations" />
      <Hero />
      <Spotlights />
      <Browser />
      <ApiComingSoon />
      <RequestCTA />
      <RushFooter />
    </div>
  );
};

export default RushIntegrationsPage;
